import { Award, Wrench, ShieldCheck, Users } from "lucide-react";

export default function AboutContent() {
  return (
    <section data-testid="about-section" className="bg-white py-20 sm:py-28 reveal">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <div className="text-xs tracking-[0.25em] uppercase font-bold text-red-600 mb-4">
              — Qui sommes-nous
            </div>
            <h2 className="font-display font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.95] text-[#0A0A0A]">
              Une équipe<br />
              de serruriers<br />
              <span className="text-red-600">vraiment pros.</span>
            </h2>
          </div>

          <div className="lg:col-span-7 space-y-5 text-slate-600 text-base sm:text-lg leading-relaxed">
            <p>
              <strong className="text-[#0A0A0A]">SOS Serrurier Express</strong> est une équipe de
              serruriers professionnels intervenant près de chez vous 24h/24 et 7j/7,
              avec un seul objectif : vous sortir de votre situation rapidement, sans dégât et
              sans surprise sur la facture.
            </p>
            <p>
              Nous installons aussi des serrures certifiées A2P, des blindages de porte,
              des coffres-forts homologués et les serrures connectées des grandes marques du marché.
            </p>
            <p>
              <strong className="text-[#0A0A0A]">Notre engagement, c'est la transparence.</strong>{" "}
              Tarif annoncé au téléphone, devis détaillé écrit avant toute intervention,
              facture conforme assurance, et garantie de 2 ans pièces et main-d'œuvre.
            </p>
          </div>
        </div>

        {/* Pillars */}
        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-black/10">
          {[
            { ic: Award, t: "15+ ans d'expertise", d: "Une équipe de serruriers formés et certifiés." },
            { ic: Wrench, t: "Matériel A2P", d: "Serrures et blindages certifiés assurance." },
            { ic: ShieldCheck, t: "Devis transparent", d: "Tarif fixe annoncé avant intervention." },
            { ic: Users, t: "12 000+ clients", d: "Particuliers et professionnels nous font confiance." },
          ].map((p, i) => {
            const Ic = p.ic;
            return (
              <div key={i} className="bg-white p-7 hover:bg-[#F3F4F6] transition">
                <Ic className="w-7 h-7 text-red-600" strokeWidth={2} />
                <div className="mt-4 font-display font-black text-lg uppercase tracking-tight">{p.t}</div>
                <div className="mt-1 text-sm text-slate-600">{p.d}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
